export enum SiteIntegrationType {
    PropertyMe = 'PropertyMe',
    PropertyTree = 'PropertyTree'
}